import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for managing client payments
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create();
    
    const getPaymentInfo = (caseid) => api.get(ApiPaths.GET_PAYMENT_INFO(caseid));
    const completePayment = (url) => api.post(ApiPaths.COMPLETE_PAYMENT, { confirmationLink: url });

    // Return back a collection of functions
    return {
        getPaymentInfo, completePayment
    }
}

// let's return back our create method as the default.
export default {
    create
}